import { Component, Input } from '@angular/core';
import { SemiCircleUtilService } from './semi-circle-util.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[semiCircle]',
    templateUrl: './semi-circle.component.html',
    styleUrls: ['./semi-circle.component.scss'],
})
export class SemiCircleComponent {
    @Input() r = 100;
    @Input() cx = 10;
    @Input() cy = 10;

    @Input() fromAngle = 220;
    @Input() toAngle = 140;
    @Input() numberOfTicks = 1;

    @Input() fill = 'transparent';
    @Input() strokeWidth = 30;
    @Input() color = 'gray';
    @Input() tickWidth = 1;

    get perimeter(): number {
        return Math.PI * 2 * this.r;
    }

    get strokeDashOffset(): number {
        return -(this.perimeter * this.fromAngle) / 360;
    }

    get strokeDashArray(): number[] {
        const length = this.getSemicircleAngleLength();
        const arr = [];

        if (this.numberOfTicks <= 1) {
            arr.push(length);
        } else {
            const numberOfSpacesBetweenTicks = this.numberOfTicks - 1;
            const tickAndSpaceEqualLength = length / (this.numberOfTicks + numberOfSpacesBetweenTicks);
            const tickLength = Math.min(this.tickWidth, tickAndSpaceEqualLength);
            const spaceLength = (length - tickLength * this.numberOfTicks) / numberOfSpacesBetweenTicks;

            let total = 0;
            const VERY_SMALL_NUMBER = tickLength / 2;
            while (total < length) {

                if (total < length) {
                    arr.push(tickLength);
                    total += tickLength;
                }
                if (total + VERY_SMALL_NUMBER < length) {
                    arr.push(spaceLength);
                    total += spaceLength;
                } else {
                    break;
                }
            }
        }

        arr.push(this.perimeter - length);

        return arr;
    }

    constructor(private semiCircleUtilService: SemiCircleUtilService) {
        if (this.fromAngle < 0 ||
            this.fromAngle > 360 ||
            this.toAngle < 0 ||
            this.toAngle > 360
        ) {
            throw Error('Invalid arguments');
        }
    }

    getStrokeColor(): string {
        return this.color === 'heatRed' || this.color === 'coolBlue' ? '' : this.color;
    }

    getStrokeColorClass(): object {
        return this.color === 'heatRed' || this.color === 'coolBlue' ? {[this.color]: true} : {};
    }

    private getSemicircleAngleLength(): number {
        return this.semiCircleUtilService.getSemicircleAngleLength(this.fromAngle, this.toAngle, this.perimeter);
    }

}
